/*
 * Empowers the submenu on the U1 template. Submenu
 * scroll the content section to the associated paragraph
 *
 * @author BarrelNY
 *
 */

var Waypoints = {
	init:function(){
		//What templates should trigger this module?
		var templates = [
			'body.U1-template',
			'body.U2-template',
			'body.U1-template-test',
			'body.penthouse-page'
		].join();

		if (!$(templates).length) return;

		this.menu = '.current-menu-item .sub-menu';
		this.el = '[class^="section-"].content';
		this.events();
	},

	events:function(){
		$(document).on('click', '.current-menu-item .sub-menu a', this.determineAnchor.bind(this));
	},

	/*
	 * Gets the event's current target and triggers a scroll
	 * to the content section (fullpage) if necessary
	 * and a scroll of the content section to the
	 * correct paragraph + image
	 *
	 * @param	obj	event object
	 * @returns void
	 */
	determineAnchor:function(e){
		var
			$el = $(e.currentTarget),
			sel = $el.attr('href'),
			$anchor = $(sel),
			dur;

		if ($anchor.length){
			if ( !this.isContentSection() && !MUR.isSmall()){
				this.scrollToContentSection(e);
				dur = 0;
			} else {
				dur = 1500;
			}

			this.prepareContentSection($anchor,dur);
		}

		return false;
	},

	/*
	 * Are we already viewing the content seciton?
	 *
	 * @params	void
	 * @returns	boolean
	 */
	isContentSection:function(){
		var isActive = $('.content[class^="section-"]').hasClass('active');
		if (isActive)
			return true;
		return false;
	},

	/*
	 * get the anchor to navigate to
	 * @param	obj	event object
	 * @returns void
	 */
	scrollToContentSection:function(evt){
		var index = $('.content').index('[class^="section-"]') + 1;

		MUR.anchorTriggered = true;

		if ( $('body.U1-template').length ) {
			$.fn.fullpage.moveTo(index);
		} else {
			var offset = $(evt.currentTarget.hash).offset().top;
			var current = $(document).scrollTop();
			var submenuHeight = $('.header-links > .menu-item.current-menu-item > .sub-menu').innerHeight();
			var headerHeight = {
				full: 144+submenuHeight,
				minimize: 60+submenuHeight
			};

			if(current > offset){
				offset = offset - headerHeight.full
			} else {
				offset = offset - headerHeight.minimize
			}

			$('html, body').stop().animate({
				scrollTop: offset
			}, 700, 'swing')

		}
	},

	/*
	 * scroll the content section to the correct
	 * position. Dependent on the scrollTop prop as
	 * jQuery's offset() and postion() functions are
	 * unusable in this case
	 *
	 * @param	obj	Jquery object of anchor to scroll to
	 * @param	int	animation duration
	 * @returns void
	 */
	prepareContentSection:function($anchor,dur){
		var
			relativeOffset = $anchor[0].offsetTop,
			offset = 100;

		if ( MUR.isSmall() ){
			$('html,body')
			.stop()
			.animate({
				scrollTop: $anchor.offset().top - 100
			},10);
		} else {
			$(this.el).find('.scroll')
			.stop()
			.animate({
				scrollTop: (relativeOffset - offset)
			},dur);
		}
	},

	/*
	 * Prep for re-init
	 * @param	void
	 * @returns void
	 */
	drop:function(){
		MUR.anchorTriggered = false;
		$('.current-menu-item .sub-menu a').off(this.determineAnchor);
	}
}

module.exports = Waypoints;
